function doModalDrawer() {
  if (customElements.get("modal-drawer-trigger")) return null;

  class ModalDrawerTrigger extends HTMLElement {
    constructor() {
      super();
      this.getContentId = this.dataset.getContentId;
      if (this.dataset.getContentId === "0") {
        console.log(`this.dataset.getContentId === "0"`);
        return undefined;
      }

      this.modalContent = document.querySelector(
        `[data-modal-content-id="${this.dataset.getContentId}"]`
      );
      if (this.modalContent == null) {
        console.log(`this.modalContent == null`);
        return undefined;
      }
      this.init();
    }

    init() {
      this.closest("li").addEventListener("click", () => {
        this.showModalContent();
      });

      this.modalContent
        .querySelector(".icon-circle-close")
        .addEventListener("click", () => {
          this.hideModalContent();
        });

      this.onClickOutside(this.modalContent, () => this.hideModalContent());
    }

    showModalContent() {
      this.modalContent.classList.add("showModalContent");
    }

    hideModalContent() {
      this.modalContent.classList.remove("showModalContent");
    }

    onClickOutside(ref, handler) {
      const listener = (event) => {
        if (!ref || ref.contains(event.target)) {
          return;
        }
        handler(event);
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);

      return;
    }
  }

  customElements.define("modal-drawer-trigger", ModalDrawerTrigger);
}

doModalDrawer();
